import * as React from 'react';
import { ControlGroup, Menu, ActionHeading, ActionFooter, Button } from '../';
import { Trigger, StyledPopover } from './Picker.styles';
import { useSelected } from '../../utils/hooks/useSelected';
export var Picker = function (props) {
    var actionHeading = props.actionHeading, actionHeadingIcon = props.actionHeadingIcon, defaultValue = props.defaultValue, cancelButtonText = props.cancelButtonText, onApply = props.onApply, applyButtonText = props.applyButtonText;
    var _a = useSelected(defaultValue), selected = _a.selected, select = _a.select, cancel = _a.cancel, apply = _a.apply, active = _a.active;
    var handleSelect = React.useCallback(function (item) { return function () {
        select(item);
    }; }, []);
    var handleCancel = React.useCallback(function (cb) { return function () {
        cancel();
        cb();
    }; }, []);
    var handleApply = React.useCallback(function (cb) { return function () {
        apply();
        onApply(selected);
        cb();
    }; }, [selected]);
    return (React.createElement(Menu, { onMenuOffClickClose: cancel }, function (_a) {
        var isOpen = _a.isOpen, toggle = _a.toggle, close = _a.close;
        return (React.createElement(React.Fragment, null,
            React.createElement(Trigger, { onClick: toggle, appearance: "outline", icon: actionHeadingIcon !== null && actionHeadingIcon !== void 0 ? actionHeadingIcon : undefined }, active.label),
            isOpen ? (React.createElement(StyledPopover, { left: true },
                React.createElement(ActionHeading, null, actionHeading),
                props.children({
                    selected: selected,
                    select: handleSelect
                }),
                React.createElement(ActionFooter, { right: true },
                    React.createElement(ControlGroup, { extraTight: true },
                        React.createElement(Button, { appearance: "plain", thin: true, onClick: handleCancel(close) }, cancelButtonText !== null && cancelButtonText !== void 0 ? cancelButtonText : 'Cancel'),
                        React.createElement(Button, { primary: true, appearance: "outline", thin: true, onClick: handleApply(close), disabled: active.value === selected.value }, applyButtonText !== null && applyButtonText !== void 0 ? applyButtonText : 'Apply'))))) : null));
    }));
};
//# sourceMappingURL=Picker.js.map